module.exports = __webpack_public_path__ + "static/media/2.d8f17a32.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/400/2.png
// module id = 735
// module chunks = 0